/**
 * Converts an RGB value into a hex string.
 * @param r Red value
 * @param g Green value
 * @param b Blue value
 */
export function rgbToHex(r: number, g: number, b: number): string {
  if (r > 255 || g > 255 || b > 255) throw "Invalid color component";
  return ((r << 16) | (g << 8) | b).toString(16);
}
const isHTML = (obj: unknown): obj is HTMLElement => obj instanceof HTMLElement;

export function findPos(obj: HTMLElement) {
  let left = 0,
    top = 0;
  const pos = { x: 0, y: 0 };
  let el: HTMLElement = obj;
  if (el.offsetParent) {
    do {
      left += el.offsetLeft;
      top += el.offsetTop;
      el = (isHTML(el.offsetParent) ? el.offsetParent : null)!;
    } while (el.offsetParent);
    pos.x = left;
    pos.y = top;
  }
  return pos;
}
